import Axios from 'axios'
import store from '../store'

export default {
  getUrlBase() {
    const tenantId = store.getters['Client/clientId']
    return `api/v1/${tenantId}`
  },
  getAreas() {
    return Axios.get(`${this.getUrlBase()}/areas`, {
      ignoreGlobalCatch: true,
    })
  },
  getArea(id) {
    return Axios.get(`${this.getUrlBase()}/areas/${id}`, {
      ignoreGlobalCatch: true,
    })
  },
  saveArea(payload) {
    return Axios.post(`${this.getUrlBase()}/areas`, payload, {
      ignoreGlobalCatch: true,
    })
  },
  editArea(payload) {
    return Axios.put(`${this.getUrlBase()}/areas/${payload.id}`, payload, {
      ignoreGlobalCatch: true,
    })
  },
  removeArea(id) {
    return Axios.delete(`${this.getUrlBase()}/areas/${id}`, {
      ignoreGlobalCatch: true,
    })
  },
  getAreaDevices(areaId) {
    return Axios.get(`${this.getUrlBase()}/areas/${areaId}/devices`)
  },
  saveAreaDevices(areaId, devicesIds) {
    return Axios.post(`${this.getUrlBase()}/areas/${areaId}/devices`, devicesIds, {
      ignoreGlobalCatch: true,
    })
  },
  getBehavior(areaId) {
    return Axios.get(`${this.getUrlBase()}/areas/${areaId}/behavior`, {
      ignoreGlobalCatch: true,
    })
  },
  saveBehavior(areaId, behavior) {
    return Axios.post(`${this.getUrlBase()}/areas/${areaId}/behavior`, behavior, {
      ignoreGlobalCatch: true,
    })
  }
}
